import { render, staticRenderFns } from "./Sign-In.vue?vue&type=template&id=48a16624&scoped=true"
import script from "./Sign-In.vue?vue&type=script&lang=js"
export * from "./Sign-In.vue?vue&type=script&lang=js"
import style0 from "./Sign-In.vue?vue&type=style&index=0&id=48a16624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a16624",
  null
  
)

export default component.exports